import { NodesTableRow } from "@features/results/Result/NodesTable"
import { Delete } from "@mui/icons-material"
import { Tooltip } from "@mui/material"
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid"
import { GraphNodeData } from "@store/services/converter/types"
import { formatValuePythonic } from "@utils/format/pythonicFormat"

export const getColumns = (
  rows: NodesTableRow[],
  onRowDelete: (row: NodesTableRow) => void,
): GridColDef[] => {
  return [
    {
      field: "numericOrder",
      headerName: "",
      maxWidth: 50,
      sortable: false,
      valueFormatter: (params) => `${params.value}.`,
    },
    {
      field: "name",
      headerName: "Node",
      flex: 1,
      sortable: false,
      renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
    },
    {
      field: "unit",
      headerName: "Unit",
      width: 250,
      sortable: false,
      renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      renderHeader: (params) => <strong>{params.colDef.headerName}</strong>,
      getActions: (params) => [
        // eslint-disable-next-line react/jsx-key
        <Tooltip title={rows.length <= 2 ? "Can not delete one of two last nodes" : "Delete"}>
          <span>
            <GridActionsCellItem
              icon={<Delete />}
              disabled={rows.length <= 2}
              label="Delete"
              onClick={() => onRowDelete(params.row)}
            />
          </span>
        </Tooltip>,
      ],
    },
  ]
}

export const getRows = (nodesData: GraphNodeData[]): NodesTableRow[] => {
  return nodesData.map((nodeData, index) => {
    return {
      numericOrder: index + 1,
      id: nodeData.node.name,
      name: nodeData.display.label,
      unit: formatValuePythonic("", nodeData.display["Unit Format"]) || "-",
    }
  })
}
